import CopyGraphic from './copygraphic'

export default CopyGraphic